{
  "search": "검색",
  "searchWithin": "다음 범위 내 검색:"
}
